import { Button } from '@fluentui/react-components';
import { AddFilled, FluentIcon } from '@fluentui/react-icons';
import { useContext } from 'react';
import { SignInContext, USER_GROUPS } from '@modules/users';

type Props = {
  onStart: () => void;
  disabled?: boolean;
  label?: string;
  icon?: FluentIcon;
  className?: string;
};

const StartDetectionButton = ({
  onStart,
  disabled,
  label = 'Start detection',
  icon: Icon = AddFilled,
  className = 'w-fit',
}: Props) => {
  const { user } = useContext(SignInContext);
  const isAdmin = user.groups.includes(USER_GROUPS.ADMIN);

  return (
    <Button
      appearance="primary"
      size="medium"
      disabled={disabled || !isAdmin}
      icon={<Icon />}
      onClick={onStart}
      className={className}
    >
      {label}
    </Button>
  );
};

export default StartDetectionButton;
